import { colors } from "constants/colors";
import styled from "styled-components";

export type StyledTimeInputProps = {
  height?: string;
  width?: string;
};

export const StyledTimeInput = styled.input.attrs({ type: "time" })`
  background: ${colors.form.background};
  font-size: 16px;
  height: ${({ height }: StyledTimeInputProps) => height || "2rem"};
  width: ${({ width }: StyledTimeInputProps) => width || "6.5rem"};
  padding: 0.5rem 0.75rem 0.5rem;
  box-sizing: border-box;
  border-radius: 5px;
  border: 0px;

  &:disabled {
    background: ${colors.disable};
  }

  &:focus {
    background: ${colors.form.focused};
  }
`;
